import * as React from "react";

export default function InlineList({
  children,
  sep = ", ",
  finalSep = null,
  Wrap = React.Fragment,
  wrapProps = {},
  ...props
}) {
  finalSep = finalSep || sep;
  // Filter out null elements, but fix keys before doing that, so that
  // the keys don't get messed up when an element becomes non-null
  const items = children
    .map((child, index) => {
      return { element: child, key: child?.key || index };
    })
    .filter((item) => item.element);

  return (
    <React.Fragment {...props}>
      {items.map((item, i) => (
        <React.Fragment key={item.key}>
          <Wrap {...wrapProps}>{item.element}</Wrap>

          {i < items.length - 2 ? sep : null}
          {i == items.length - 2 ? finalSep : null}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}
